import { MapViewerService } from '@3ddv/ngx-dvm-internal';
import { InjectionToken } from '@angular/core';

/**
 * A second, independent `MapViewerService` instance used only to silently query
 * a section's `related` map data (see `DvmService.getRelatedMapsForSection`)
 * without disturbing the main viewer the user is actually looking at.
 *
 * It's headless: initialized without a `container`, so it never renders anything.
 * Mirrors SMP's `BG_MAP_VIEWER_TOKEN` — same name/shape on purpose.
 */
export const BG_MAP_VIEWER_TOKEN = new InjectionToken<MapViewerService>(
  'BG_MAP_VIEWER_TOKEN'
);
